<h2 mat-dialog-title>{{ data?.id ? ("learning_unit_edit" | transloco) : ("learning_unit_create" | transloco) }}</h2>
<div class="pixl-form">
    <mat-divider></mat-divider>

    <mat-tab-group>
        <mat-tab [label]="'base_data' | transloco">
            <mat-dialog-content
                [formGroup]="form"
                class="grid"
            >

                <mat-form-field class="full-width">
                    <mat-label>{{ "title" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="title"
                    />
                </mat-form-field>

                <mat-form-field class="full-width">
                    <mat-label>{{ "subtitle" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="subtitle"
                    />
                </mat-form-field>

                @if (hasPixlEditorDescription()) {
                    <div class="full-width border-area">
                        <mat-label>{{ "description" | transloco }}</mat-label>
                            <pixl-editor
                                [htmlString]="form.get('description')?.value || ''"
                            [editorHeight]="'auto'"
                            [bearerToken]="authToken!"
                            [assetUrl]="assetsUrl"
                            [mediaUrl]="mediaUrl"
                            [(editedHtmlString)]="descriptionHtml"
                        ></pixl-editor>
                    </div>
                } @else {
                    <mat-form-field class="full-width">
                        <mat-label>{{ "description" | transloco }}</mat-label>
                        <input
                            matInput
                            type="text"
                            required
                            placeholder=""
                            formControlName="description"
                        />
                    </mat-form-field>
                }

                @if (hasPixlEditorDidacticHint()) {
                    <div class="full-width border-area">
                        <mat-label>{{ "didactic_hint" | transloco }}</mat-label>
                        <pixl-editor
                            [htmlString]="form.get('didactic_hint')?.value || ''"
                            [editorHeight]="'auto'"
                            [bearerToken]="authToken!"
                            [assetUrl]="assetsUrl"
                            [mediaUrl]="mediaUrl"
                            [(editedHtmlString)]="didacticHintHtml"
                        ></pixl-editor>
                    </div>
                }

                <div class="preview-container border-area full-width">
                    <div class="content">
                        <div>
                            <button
                                class="extend-button"
                                mat-stroked-button
                                (click)="openImageChoice()"
                            >
                                <mat-icon>add_photo_alternate</mat-icon>
                                {{ "select_preview_image" | transloco }}
                            </button>
                        </div>

                        @if (getImageName() && getImageName().length > 0) {
                        <div>
                            <div class="media-container">
                                <div class="media-item">
                                    <div class="media-item">
                                        <img
                                            src="{{ imageUrl() }}"
                                            alt=""
                                            class="preview"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-1">
                            <span class="info cut-long-text">{{ getImageName() }}</span>
                        </div>

                        <div>
                            <button
                                mat-icon-button
                                (click)="deleteMediaEntry()"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        }
                    </div>
                </div>

                <mat-form-field>
                    <mat-label>{{ "application" | transloco }}</mat-label>
                    <mat-select formControlName="consumer">
                        @for (consumer of consumers$ | async; track consumer.id) {
                        <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="filter-item">
                    <pixl-state-cb
                        [required]="true"
                        [initValue]="form.get('status')?.value"
                        (onStateChange)="statusChanged($event)"
                    />
                </div>

                <mat-form-field>
                    <mat-label>{{ "teaching_phase" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="lesson_section"
                    />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ "processing_time" | transloco }}</mat-label>
                    <input
                        matInput
                        type="number"
                        formControlName="processing_time"
                    />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ "learning_unit_type" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="learning_unit_type"
                    />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ "learning_unit_goal" | transloco }}</mat-label>
                    <mat-select formControlName="learning_unit_goal">
                        <mat-option value="voluntarily">{{ "voluntary" | transloco }}</mat-option>
                        <mat-option value="mandatory">{{ "mandatory" | transloco }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="full-width">
                    <pixl-multi-combo-entity-search
                        [label]="moduleLabel"
                        [observable$]="modules$"
                        [namingColumn]="'title'"
                        [externalSearch]="true"
                        (onStateChange)="receiveModuleData($event)"
                        (onSearchChange)="receiveModuleQuery($event)"
                        (scrolledToEnd)="loadMoreModules($event)"
                        [(selectedValues)]="selectedModules"
                    >
                    </pixl-multi-combo-entity-search>
                </div>

                <div class="border-area full-width">
                    <div class="multi-select mt-2">
                        <pixl-multi-combo-entity-search
                            [label]="learningSectionLabel"
                            [observable$]="learningSections$"
                            [namingColumn]="'name'"
                            [externalSearch]="true"
                            (onStateChange)="receiveLearningSectionData($event)"
                            (onSearchChange)="receiveLearningSectionQuery($event)"
                            (scrolledToEnd)="loadMoreLearningSections($event)"
                            [(selectedValues)]="selectedLearningSections"
                        >
                        </pixl-multi-combo-entity-search>
                    </div>
                    <div class="mb-1">{{ "arrange_drag_drop" | transloco }}</div>
                    <div
                        cdkDropList
                        class="order-list"
                        (cdkDropListDropped)="reOrderSelectedLearningSections($event)"
                    >
                        @for (learningSection of selectedLearningSections; track trackLearningSectionsById($index,
                        learningSection)) {
                        <div
                            class="order-box"
                            cdkDrag
                        >
                            {{ learningSection.title }}
                        </div>
                        }
                    </div>
                </div>
            </mat-dialog-content>
        </mat-tab>
        <mat-tab [label]="(selectedConsumerName$ | async) || ('metadata' | transloco)">
            <mat-dialog-content class="grid">
                <pixl-object-consumer-metadata
                    [parentForm]="form"
                    [objectType]="'learning_unit'"
                ></pixl-object-consumer-metadata>
            </mat-dialog-content>
        </mat-tab>
    </mat-tab-group>
    <br />
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button
            mat-button
            (click)="cancel()"
        >{{ "cancel" | transloco }}</button>
        <button
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="form.invalid"
        >{{ "save" | transloco }}</button>
    </mat-dialog-actions>
</div>